import { render, staticRenderFns } from "./SushiDiaoxian.vue?vue&type=template&id=12ae4108&scoped=true&"
import script from "./SushiDiaoxian.vue?vue&type=script&lang=js&"
export * from "./SushiDiaoxian.vue?vue&type=script&lang=js&"
import style0 from "./SushiDiaoxian.vue?vue&type=style&index=0&id=12ae4108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae4108",
  null
  
)

export default component.exports